import {Redirect, Route, Switch} from 'react-router-dom';
//import MainHeader from "./components/header/MainHeader";
import MainPage from "./pages/MainPage";
import {useState} from "react";
import MonthPage from "./pages/MonthPage";
import TournamentPage from "./pages/TournamentPage";
import DataContext from "./components/DataContext";
import CategoryPage from "./pages/CategoryPage";
import FilePage from "./pages/FilePage";
import {Row, Col} from "react-bootstrap";
import './scss/main.scss';
import Sidebar from "./components/sidebar/Sidebar";
import TreeView from "./components/Tree/TreeView";

import Breadcrumbs from "./components/breadcrumbs/PureBreadcrumb";
import NotFound from "./pages/NotFound";
function App() {
    const [data,setData] = useState(() => {
        try {
            fetch('https://hts.hr/api/archive',
            //fetch('http://localhost:3000/data-nino.json',
                {
                    headers : {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    crossDomain: true
                }
            )
                .then(function(response){
                    console.log(response);
                    return response.json();
                })
                .then(function(myJson) {
                    console.log(myJson);
                    setData(myJson)
                });
        } catch (e) {
            console.log(e);
            return null;
        }
    });

  return (
      <DataContext.Provider value={{data: data}}>
          {/*<MainHeader />*/}
          <aside className={'d-none d-sm-block'}>
              <Sidebar />
              <TreeView />
          </aside>
          <div id={'main-container'}>
              <Row>
                  <Col sm={12}>
                      <Breadcrumbs />
                      <Switch>
                          <Route path="/" exact>
                              <Redirect to='arhiva'/>
                          </Route>
                          <MainPage path="/arhiva" exact />
                          <MonthPage path="/arhiva/:year" exact />
                          <TournamentPage path="/arhiva/:year/:month" exact />
                          <CategoryPage path="/arhiva/:year/:month/:tournament" exact />
                          <FilePage path="/arhiva/:year/:month/:tournament/:categorie" exact />
                          <NotFound path="*"  />
                      </Switch>
                  </Col>
              </Row>
          </div>


      </DataContext.Provider>
  );
}

export default App;
